module.exports = __webpack_public_path__ + "static/img/CgoRC2ORj4-AaSJGAAUEbGLf5u8637.3e58327.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CgoRC2ORj4-AaSJGAAUEbGLf5u8637.jpg
// module id = KBNT
// module chunks = 73